"use strict";
/**
 * CONNOX GMBH CONFIDENTIAL
 * ________________________
 *
 * Copyright (c) 2005 - 2022 Connox GmbH, All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Connox GmbH and its suppliers, if any. The intellectual and
 * technical concepts contained herein are proprietary to Connox GmbH and
 * its suppliers and may be covered by German Laws and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * strictly forbidden unless prior written permission is obtained from
 * Connox GmbH.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartFactory = void 0;
const Cart_1 = require("./Cart");
const CartData_1 = require("./CartData");
const CartRequestHandler_1 = require("./requestHandlers/CartRequestHandler");
class CartFactory {
    constructor() {
        this.existingCart = null;
        this.awaitingCartPromise = null;
        this.awaitingCartPutPromise = null;
    }
    /**
     * Clears the existing cart to reload it from the api - only usefull after changing the shop Id
     */
    clearCart() {
        this.existingCart = null;
    }
    /**
     * Get the current cart or create a new one (this should be preferred over `getCart(): Cart | null`)
     * @returns {Promise<Cart | Error>}
     */
    generateCart(shopId, visitorId, config, isBroadcastAllowed = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.existingCart && this.existingCart.visitorId === visitorId) {
                return this.existingCart;
            }
            if (this.awaitingCartPromise) {
                yield this.awaitingCartPromise;
                if (this.awaitingCartPutPromise) {
                    yield this.awaitingCartPutPromise;
                }
                if (this.existingCart)
                    return this.existingCart;
            }
            if (this.awaitingCartPutPromise) {
                yield this.awaitingCartPutPromise;
                return this.existingCart;
            }
            this.awaitingCartPromise = CartRequestHandler_1.CartRequestHandler.createCart(shopId, visitorId);
            const cartResponseData = yield this.awaitingCartPromise;
            let rawCartData;
            if (config) {
                this.awaitingCartPutPromise = CartRequestHandler_1.CartRequestHandler.putParams(shopId, cartResponseData.cartId, config);
                rawCartData = yield this.awaitingCartPutPromise;
            }
            else {
                rawCartData = cartResponseData;
            }
            const cartData = new CartData_1.CartData(rawCartData);
            this.existingCart = new Cart_1.Cart(shopId, cartData, isBroadcastAllowed);
            this.awaitingCartPutPromise = null;
            this.awaitingCartPromise = null;
            return this.existingCart;
        });
    }
    /**
     *  Get current cart for a visitor or returns null if no cart exists
     */
    getCartForVisitorId(shopId, visitorId, isBroadcastAllowed = false) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.existingCart && this.existingCart.visitorId === visitorId) {
                return this.existingCart;
            }
            if (this.awaitingCartPromise) {
                yield this.awaitingCartPromise;
                return this.existingCart;
            }
            this.awaitingCartPromise = CartRequestHandler_1.CartRequestHandler.getCartForVisitorId(shopId, visitorId);
            const cartResponseData = yield this.awaitingCartPromise;
            this.existingCart = cartResponseData ? new Cart_1.Cart(shopId, new CartData_1.CartData(cartResponseData), isBroadcastAllowed) : null;
            this.awaitingCartPromise = null;
            return this.existingCart;
        });
    }
}
const cartFactory = new CartFactory();
exports.CartFactory = cartFactory;
